export const SOURCE_DI_DATA_DISC_TABLE = "DISC Table defined in Data Inventory"; // after DI 2.3
export const SOURCE_DI_DISC_TABLE =
  "DISC Table defined in Data Inventory (may be obsolete)"; // before DI 2.3
export const SOURCE_SDD_DATASET_URL = "Dataset URL defined in SDD";

export const getTablesFromDataSetDistributions = (dataSetDistributions) => {
  let tables = [];

  if (typeof dataSetDistributions[Symbol.iterator] === "function")
    for (const { dataDiscTables, discTables } of dataSetDistributions) {
      // dataDownloadUrls is not used, we expect only DISC tables to be used in this context

      // DISC tables after DI 2.3
      if (dataDiscTables) {
        dataDiscTables.forEach((dataDiscTable) => {
          const tableWithSource = {
            table: dataDiscTable.databaseName + "." + dataDiscTable.tableName,
            source: SOURCE_DI_DATA_DISC_TABLE,
          };
          tables.push(tableWithSource);
        });
      }

      // DISC tables before DI 2.3
      if (discTables && discTables.discDBsAndTables) {
        for (const dbTables of Object.values(discTables.discDBsAndTables)) {
          for (const table of dbTables) {
            // sample URL: https://t-hue.disc01.tadnet.net/hue/metastore/table/dummy1/tb1
            // sample URL: https://t-hue.disc01.tadnet.net/hue/metastore/table/dummy_1/tb_1
            // sample URL: https://t-hue.disc01.tadnet.net/hue/metastore/table/dummy1/tb1?type=impala
            const tabWithSource = {
              table: table.replace(
                /^.*metastore\/table\/(\w*)\/(\w*)(\?.*)?/g,
                "$1.$2"
              ),
              source: SOURCE_DI_DISC_TABLE,
            };
            tables.push(tabWithSource);
          }
        }
      }
    }

  return tables;
};

export const getTablesFromDatasetUrl = (cube) => {
  let tables = [];

  if (cube && cube.datasetUrl) {
    const tabWithSource = {
      table: cube.datasetUrl.replace(
        /^.*metastore\/table\/(\w*)\/(\w*)(\?.*)?/g,
        "$1.$2"
      ),
      source: SOURCE_SDD_DATASET_URL,
    };
    tables.push(tabWithSource);
  }

  return tables;
};
